import { SxProps } from "@mui/material";
import { Row } from "@tanstack/react-table";
import { TaskItemsTable } from "src/components";
import { TaskItemDto } from "src/http";

interface Props {
  tableId: string;
  taskItems: TaskItemDto[];
  fetchTaskItemSubtasks: (taskItemGuid: string) => Promise<void>;
  enableActions: boolean;
  sx?: SxProps;
}

const TeamTaskItemsTable = (props: Props) => {
  async function handleExpandRowClicked(
    row: Row<TaskItemDto>,
    isLoadingSubRows: boolean,
    setIsLoadingSubRows: (isLoading: boolean) => void
  ) {
    const taskItem = row.original;

    if (isLoadingSubRows || !taskItem.hasSubtasks) {
      return;
    }

    setIsLoadingSubRows(true);

    try {
      if (taskItem.subtasks.length === 0) {
        await props.fetchTaskItemSubtasks(taskItem.guid);
      }

      row.getToggleExpandedHandler()();
    } finally {
      setIsLoadingSubRows(false);
    }
  }

  return (
    <TaskItemsTable
      tableId={props.tableId}
      taskItems={props.taskItems}
      enableActions={props.enableActions}
      onExpandRowClicked={handleExpandRowClicked}
      sx={props.sx}
    />
  );
};

export { TeamTaskItemsTable };
